import type { DepartureDateFilterOptions } from '@/scopes/search/components/DepartureDateFilter/types'
import { useIntl } from '@/intl'

import * as React from 'react'
import { styled } from 'styled-components'
import { useDepartureDateFilter } from './hooks'
import { SegmentedControls } from '@sunwebgroup/uds-ui/segmented-controls'

interface TabsProps extends React.HTMLAttributes<HTMLDivElement> {
  options: DepartureDateFilterOptions
}

const StyledTabWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`

function Tabs({ options, ...rest }: TabsProps) {
  const intl = useIntl()
  const { view, setView } = useDepartureDateFilter({ options })
  return (
    <StyledTabWrapper {...rest}>
      <SegmentedControls
        defaultActive={view}
        onActiveChange={({ value }) => setView(value as 'calendar' | 'month')}
        fixed
      >
        <SegmentedControls.Segment value="calendar">
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_calendar' })}
        </SegmentedControls.Segment>
        <SegmentedControls.Segment value="month">
          {intl.formatMessage({ id: 'quicksearch_filter_departure_date_month' })}
        </SegmentedControls.Segment>
      </SegmentedControls>
    </StyledTabWrapper>
  )
}

export default styled(Tabs)``
